import React from 'react';
import { JbLogoInline } from '../../HeaderLayout/components/HeaderJbLogo/jbLogoInline';
import { styles } from './Branding.css';

type BrandingProps = {
  tagline: string;
};

export const Branding = ({ tagline }: BrandingProps) => {
  return (
    <>
      <JbLogoInline viewBox="0 0 204 33.08" style={{ width: '100%', maxWidth: '12.5rem', height: '2rem' }} />
      <div className={styles.tagLine}>{tagline}</div>
    </>
  );
};
